<template>
    <div class="BottomNavigation">
        <div class="info-list-wrap">
           <!-- <dl style="width: 25%">
                <dt>解决方案</dt>
                <dd><router-link to="/" >产品更新记录</router-link></dd>
                <dd><router-link to="/">API文档</router-link></dd>
                <dd><router-link to="/">快速入门</router-link></dd>
                <dd><router-link to="/">参考指南</router-link></dd>
            </dl>-->
            <dl style="width: 13%">
                <dt>快速导航</dt>
                <!--<dd><router-link to="/">首页</router-link></dd>-->
                <dd><span><router-link to="/">营销解决方案</router-link></span></dd>
                <dd><router-link to="/ChanPinFuWu">产品及服务</router-link></dd>
                <dd><router-link to="/AboutCompany">关于我们</router-link></dd>
            </dl>
            <dl style="width: 25%">
                <dt>&nbsp;</dt>
                <!--<dd><router-link to="/">首页</router-link></dd>-->
                <dd><router-link to="/QuanYi">我们的权益</router-link></dd>
                <dd><router-link to="/JoinCompany">加入新竹</router-link></dd>
            </dl>
            <dl style="width: 40%">
                <dt>联系我们</dt>
                <dd><router-link to="/">邮箱: xinzhukefu@xinzhu.net.cn</router-link></dd>
                <dd><router-link to="/">地址：南京市雨花台区安德门大街40号550/研发基地<br/>
                    南京市雨花台区软件大道大数据产业园3-408</router-link></dd>
            </dl>
        </div>
        <div class="bei-an-wrap">
            <div style="margin-right: 30px;">版权所有 © {{nowYear}} 江苏新竹信息技术有限公司 </div>
            <div>电信与信息服务业务许可证号：<a href="https://beian.miit.gov.cn" target = "blank">苏ICP备2024064914号</a></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BottomNavigation",
        data() {
            return{
                nowYear: undefined
            }
        },
        created() {
          this.getNowYear()
        },
        methods: {
            getNowYear() {
                var date = new Date()
                this.nowYear = date.getFullYear()
            }
        }
    }
</script>

<style scoped>
    .BottomNavigation{
        background: #303030;
    }
    .info-list-wrap{
        overflow: hidden;
        /*padding: 1.5vw 7vw;*/
        padding: 1.5vw 3vw 1.5vw 20vw;
    }
    .info-list-wrap dl{
        float: left;
        /*width: 200px;*/
        text-align: left;
        /*border: 1px solid red;*/
    }
    .info-list-wrap dt{
        color: #ffffff;
        font-size: 24px;
        letter-spacing: 2px;
        margin-bottom: 20px;
    }
    .info-list-wrap dd{
        color: #ffffff;
        font-size: 15px;
        margin-left: 0px;
        letter-spacing: 1px;
        line-height: 22px;
        margin-bottom: 10px;
    }

    a {
        text-decoration: none;  /*去除默认样式*/
        color: #cbcbcb; /*高亮的颜色*/
    }

    .bei-an-wrap{
        background: #ffffff;
        color: #636363;
        font-size: 13px;
        display: flex;
        justify-content: center;
        padding: 26px;
    }
</style>
